module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_microsoft_365-d265c59a486fe16e92997da477a66c66.png";